import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import styled from '@emotion/styled';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';

const BreadcrumbsWrapper = styled.div`
  display: inline-flex;
  padding: 20px 10px;
  font-size: 1rem;
  background: #ffffff;
`;

const RedirectItem = styled(NavLink)`
  text-decoration: none;
  color: text.secondary;
  cursor: pointer;
  &.active {
  }
`;

const SeparatorWrapper = styled.div`
  padding: 0 10px;
  color: '#939393';
`;

function Breadcrumbs() {
  const breadcrumbs = useSelector((state) => state.breadcrumbs);

  const renderPath = () => {
    const list = [];

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < breadcrumbs.path.length; ++i) {
      if (i !== 0) {
        list.push(<SeparatorWrapper key={`${i}sep`}>/</SeparatorWrapper>);
      }

      list.push(
        <RedirectItem
          key={i}
          to={breadcrumbs.path[i].url}>
          {breadcrumbs.path[i].icon ? (
            <ListItemButton>
              <ListItemIcon>{breadcrumbs.path[i].icon}</ListItemIcon>
            </ListItemButton>
          ) : null}
          <Typography
            component="div"
            variant="body2"
            sx={{
              color:
                i === breadcrumbs.path.length - 1
                  ? 'text.primary'
                  : 'text.secondary',
            }}>
            {breadcrumbs.path[i].label}
          </Typography>
        </RedirectItem>,
      );
    }
    return list;
  };

  return (
    <BreadcrumbsWrapper>{renderPath(breadcrumbs.path)}</BreadcrumbsWrapper>
  );
}

export default Breadcrumbs;
